<template>
	<div class="print-designer">
		<!-- 左侧组件库 -->
		<div class="designer-left">
			<h3>📦 组件库</h3>
			<div class="ep-draggable-item" tid="defaultModule.text" title="文本">📄 文本</div>
			<div class="ep-draggable-item" tid="defaultModule.image" title="图片">🖼️ 图片</div>
			<div class="ep-draggable-item" tid="defaultModule.barcode" title="条形码">📊 条形码</div>
			<div class="ep-draggable-item" tid="defaultModule.qrcode" title="二维码">📱 二维码</div>
			<div class="ep-draggable-item" tid="defaultModule.hline" title="横线">📏 横线</div>
			<div class="ep-draggable-item" tid="defaultModule.vline" title="竖线">📏 竖线</div>
			<div class="ep-draggable-item" tid="defaultModule.rect" title="矩形">🔲 矩形</div>
			<div class="ep-draggable-item" tid="defaultModule.table" title="表格">📋 表格</div>
		</div>

		<!-- 中间设计区 -->
		<div class="designer-center">
			<div class="toolbar">
				<!-- 纸张尺寸快捷按钮组 -->
				<div class="size-group">
					<span class="size-label">纸张尺寸：</span>
					<button @click="setPaperSize(210, 297)" :class="{ active: isActiveSize(210, 297) }">A4</button>
					<button @click="setPaperSize(297, 420)" :class="{ active: isActiveSize(297, 420) }">A3</button>
					<button @click="setPaperSize(148, 210)" :class="{ active: isActiveSize(148, 210) }">A5</button>
					<button @click="setPaperSize(176, 250)" :class="{ active: isActiveSize(176, 250) }">B5</button>
					<button @click="setPaperSize(216, 279)" :class="{ active: isActiveSize(216, 279) }">Letter</button>
					<button @click="setPaperSize(241, 280)"
						:class="{ active: isActiveSize(241, 280) }">送货单(241x280)</button>
					<button @click="setPaperSize(241, 140)"
						:class="{ active: isActiveSize(241, 140) }">快递单(241x140)</button>
				</div>
				<!-- 自定义尺寸输入框 -->
				<div class="custom-size">
					<input type="number" v-model.number="customWidth" placeholder="宽度(mm)" step="1" min="1">
					<span> x </span>
					<input type="number" v-model.number="customHeight" placeholder="高度(mm)" step="1" min="1">
					<button @click="applyCustomSize">应用</button>
				</div>

				<!-- ========== 数据库模板管理区域（新增） ========== -->
				<div class="template-group">
					<input type="text" v-model="templateName" placeholder="模板名称" class="template-name-input">
					<select v-model="selectedTemplateId" @change="loadSelectedTemplate" class="template-select">
						<option value="">-- 选择模板 --</option>
						<option v-for="tpl in templateList" :key="tpl.id" :value="tpl.id">
							{{ tpl.name }}
						</option>
					</select>
					<button @click="saveTemplateToDb" class="btn-db-save">💾 保存到数据库</button>
					<button @click="deleteTemplate" v-if="selectedTemplateId" class="btn-db-delete">🗑️ 删除模板</button>
				</div>

				<!-- 原有操作按钮组 -->
				<div class="action-buttons">
					<button @click="saveTemplate">💾 保存模板</button>
					<button @click="loadTemplate">📂 加载示例</button>
					<button @click="printPreview">🖨️ 打印预览</button>
					<button @click="printDirect">⚡ 直接打印</button>
					<button @click="clearAllElements" class="danger">🗑️ 清空内容</button>
					<button @click="rotatePaper" class="rotate">🔄 旋转纸张</button>
				</div>
			</div>
			<!-- 分页容器（修改样式，使其可见） -->
			<div class="hiprint-printPagination"></div>
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
		</div>

		<!-- 右侧属性面板 -->
		<div class="designer-right">
			<h3>⚙️ 属性设置</h3>
			<div id="PrintElementOptionSetting"></div>
		</div>
	</div>
</template>

<script>
	import {
		hiprint,
		defaultElementTypeProvider,
		disAutoConnect
	} from 'vue-plugin-hiprint'
	import request from '@/utils/request'

	// 配置后端 API 地址（请根据实际情况修改）
	const apiBase = 'http://localhost:5000/api/Templates'

	export default {
		name: 'PrintDesigner',
		data() {
			return {
				hiprintTemplate: null,
				customWidth: 210,
				customHeight: 297,
				currentWidth: 210,
				currentHeight: 297,
				// ========== 数据库模板管理数据 ==========
				templateName: '',
				selectedTemplateId: '',
				templateList: []
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.initDesigner()
				this.fetchTemplates() // 加载模板列表
			})
		},
		beforeDestroy() {
			if (this.hiprintTemplate) {
				this.hiprintTemplate.destroy()
			}
			if (this.provider) {
				hiprint.removeProvider(this.provider)
			}
		},
		methods: {
			initDesigner() {
				disAutoConnect()

				if (!window.$) {
					console.error('❌ jQuery 未加载')
					return
				}

				try {
					const provider = new defaultElementTypeProvider()
					hiprint.init({
						providers: [provider]
					})
					console.log('✅ hiprint.init 成功')

					const $items = $('.ep-draggable-item')
					if ($items.length === 0) {
						console.warn('⚠️ 未找到 .ep-draggable-item 元素')
						return
					}
					hiprint.PrintElementTypeManager.buildByHtml($items)
					console.log(`✅ 已构建 ${$items.length} 个可拖拽组件`)

					this.hiprintTemplate = new hiprint.PrintTemplate({
						template: {},
						settingContainer: '#PrintElementOptionSetting',
						paginationContainer: '.hiprint-printPagination',
						fontList: [{
								title: '微软雅黑',
								value: 'Microsoft YaHei'
							},
							{
								title: '宋体',
								value: 'SimSun'
							},
							{
								title: '黑体',
								value: 'SimHei'
							}
						],
						onDataChanged: (type, json) => {
							console.log('📝 模板已变更', type, json)
						}
					})

					// 添加默认面板
					this.hiprintTemplate.addPrintPanel({
						width: this.currentWidth,
						height: this.currentHeight,
						paperHeader: 20,
						paperFooter: 20
					})

					// 渲染设计器
					this.hiprintTemplate.design('#hiprint-printTemplate')
					console.log('✅ 设计器渲染完成')
				} catch (error) {
					console.error('❌ 初始化失败:', error)
				}
			},
			checkPaperHeight() {
				if (!this.hiprintTemplate) return;
				const json = this.hiprintTemplate.getJson();
				const panel = json.panels[0];
				if (!panel) {
					console.warn('没有面板');
					return;
				}
				const paperHeightPt = panel.height * 2.83465;
				const maxBottom = panel.elements.reduce((max, el) => {
					const bottom = (el.options.top || 0) + (el.options.height || 0);
					return Math.max(max, bottom);
				}, 0);
				console.log('纸张高度(pt):', paperHeightPt);
				console.log('元素最大底部(pt):', maxBottom);
				if (maxBottom > paperHeightPt) {
					console.warn('内容超出纸张，超出高度:', (maxBottom - paperHeightPt).toFixed(2), 'pt');
					console.warn('建议增加纸张高度或上移/缩小元素');
				} else {
					console.log('✅ 所有元素都在一页内');
				}
			},
			/**
			 * 通用的设置模板 JSON 方法（兼容不同版本）
			 */
			setTemplateJson(templateJson) {
				if (!this.hiprintTemplate) return false
				if (typeof this.hiprintTemplate.setTemplate === 'function') {
					this.hiprintTemplate.setTemplate(templateJson)
					return true
				} else if (typeof this.hiprintTemplate.setJson === 'function') {
					this.hiprintTemplate.setJson(templateJson)
					return true
				} else if (typeof this.hiprintTemplate.load === 'function') {
					this.hiprintTemplate.load(templateJson)
					return true
				} else {
					console.error('❌ 未找到任何可用的模板设置方法 (setTemplate/setJson/load)')
					return false
				}
			},

			/**
			 * 切换纸张尺寸
			 */
			setPaperSize(width, height) {
				if (!this.hiprintTemplate) return
				try {
					this.hiprintTemplate.setPaper(width, height)
					this.currentWidth = width
					this.currentHeight = height
					this.customWidth = width
					this.customHeight = height
					console.log(`✅ 纸张尺寸已更改为 ${width}mm x ${height}mm`)
				} catch (error) {
					console.error('❌ 更改纸张尺寸失败:', error)
				}
			},

			// 应用自定义尺寸
			applyCustomSize() {
				if (this.customWidth > 0 && this.customHeight > 0) {
					this.setPaperSize(this.customWidth, this.customHeight)
				} else {
					alert('请输入有效的宽度和高度（正整数）')
				}
			},

			isActiveSize(width, height) {
				return this.currentWidth === width && this.currentHeight === height
			},

			// ========== 本地存储（保持不变） ==========
			saveTemplate() {
				if (!this.hiprintTemplate) return
				const json = this.hiprintTemplate.getJson()
				console.log('📦 模板 JSON:', json)
				localStorage.setItem('hiprintTemplate', JSON.stringify(json))
				alert('模板已保存到 localStorage')
			},

			loadTemplate() {
				if (!this.hiprintTemplate) return
				const saved = localStorage.getItem('hiprintTemplate')
				if (saved) {
					const templateJson = JSON.parse(saved)
					if (templateJson.panels && templateJson.panels[0]) {
						this.currentWidth = templateJson.panels[0].width
						this.currentHeight = templateJson.panels[0].height
						this.customWidth = this.currentWidth
						this.customHeight = this.currentHeight
					}
					const success = this.setTemplateJson(templateJson)
					if (success) {
						console.log('✅ 模板加载成功')
					} else {
						alert('模板加载失败，请检查控制台')
					}
				} else {
					alert('暂无保存的模板')
				}
			},

			// ========== 数据库模板管理（新增） ==========
			async fetchTemplates() {
				try {
					const res = await request.get("/api/PrintTemplate/GetAll")
					this.templateList = res.data
					debugger
				} catch (error) {
					console.error('获取模板列表失败:', error)
				}
			},

			async saveTemplateToDb() {
				if (!this.hiprintTemplate) return
				if (!this.templateName.trim()) {
					alert('请输入模板名称')
					return
				}
				const json = this.hiprintTemplate.getJson()
				try {
					await request.post(apiBase, {
						name: this.templateName,
						jsonContent: JSON.stringify(json)
					})
					alert('模板保存成功')
					this.templateName = ''
					this.fetchTemplates() // 刷新列表
				} catch (error) {
					console.error('保存模板失败:', error)
					alert('保存失败，请检查网络或后端服务')
				}
			},

			async loadSelectedTemplate() {
				if (!this.selectedTemplateId) return
				try {
					const res = await request.get(`${apiBase}/${this.selectedTemplateId}`)
					const templateJson = JSON.parse(res.data.jsonContent)
					// 加载模板
					this.setTemplateJson(templateJson)
					// 更新当前纸张尺寸显示
					if (templateJson.panels && templateJson.panels[0]) {
						this.currentWidth = templateJson.panels[0].width
						this.currentHeight = templateJson.panels[0].height
						this.customWidth = this.currentWidth
						this.customHeight = this.currentHeight
					}
					console.log('✅ 模板加载成功')
				} catch (error) {
					console.error('加载模板失败:', error)
					alert('加载模板失败')
				}
			},

			async deleteTemplate() {
				if (!this.selectedTemplateId) return
				if (!confirm('确定删除该模板吗？')) return
				try {
					await request.get(`${apiBase}/${this.selectedTemplateId}`)
					alert('删除成功')
					this.selectedTemplateId = ''
					this.fetchTemplates()
				} catch (error) {
					console.error('删除模板失败:', error)
					alert('删除失败')
				}
			},

			// ========== 其他功能（保持不变） ==========
			clearAllElements() {
				if (!this.hiprintTemplate) return
				this.hiprintTemplate.clear()
				console.log('✅ 已清空所有元素')
			},

			rotatePaper() {
				if (!this.hiprintTemplate) return
				this.hiprintTemplate.rotatePaper()
				const newWidth = this.currentHeight
				const newHeight = this.currentWidth
				this.currentWidth = newWidth
				this.currentHeight = newHeight
				this.customWidth = newWidth
				this.customHeight = newHeight
				console.log(`✅ 纸张已旋转，新尺寸: ${newWidth}mm x ${newHeight}mm`)
			},

			printPreview() {
				if (!this.hiprintTemplate) return
				this.hiprintTemplate.print({})
			},

			printDirect() {
				this.checkPaperHeight();
				// if (!this.hiprintTemplate) return
				// this.hiprintTemplate.print2({})
			}
		}
	}
</script>
<style scoped>
	/* 原有样式保持不变，仅添加数据库模板管理相关样式 */
	.print-designer {
		display: flex;
		height: 100vh;
		font-family: 'Microsoft YaHei', sans-serif;
		border: 1px solid #e8e8e8;
	}

	/* 左侧固定宽度，不压缩 */
	.designer-left {
		width: 200px;
		flex-shrink: 0;
		border-right: 1px solid #ddd;
		padding: 12px;
		background-color: #f8f9fa;
		overflow-y: auto;
	}

	.designer-left h3 {
		margin-top: 0;
		margin-bottom: 16px;
		font-size: 16px;
		text-align: center;
		color: #333;
	}

	.ep-draggable-item {
		padding: 8px 12px;
		margin-bottom: 8px;
		background-color: #fff;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		cursor: move;
		user-select: none;
		transition: all 0.2s;
		font-size: 14px;
	}

	.ep-draggable-item:hover {
		background-color: #e6f7ff;
		border-color: #1890ff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	/* 中间区域：弹性占满剩余空间，但防止溢出 */
	.designer-center {
		flex: 1;
		display: flex;
		flex-direction: column;
		background-color: #fff;
		overflow: hidden;
		/* 关键：防止被子元素撑开 */
		min-width: 0;
		/* 允许 flex 子项收缩 */
	}

	.toolbar {
		padding: 12px 16px;
		border-bottom: 1px solid #eee;
		background-color: #fafafa;
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		align-items: center;
		flex-shrink: 0;
		/* 工具栏不压缩 */
	}

	.size-group,
	.custom-size,
	.template-group,
	.action-buttons {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.size-label {
		font-weight: bold;
		color: #333;
	}

	.toolbar button {
		padding: 6px 12px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		background-color: #fff;
		cursor: pointer;
		font-size: 14px;
		transition: all 0.2s;
	}

	.toolbar button:hover {
		background-color: #1890ff;
		color: #fff;
		border-color: #1890ff;
	}

	.toolbar button.active {
		background-color: #1890ff;
		color: #fff;
		border-color: #1890ff;
	}

	.toolbar button.danger:hover {
		background-color: #f5222d;
		border-color: #f5222d;
	}

	.toolbar button.rotate:hover {
		background-color: #52c41a;
		border-color: #52c41a;
	}

	/* 新增数据库按钮样式 */
	.toolbar button.btn-db-save:hover {
		background-color: #faad14;
		border-color: #faad14;
	}

	.toolbar button.btn-db-delete:hover {
		background-color: #f5222d;
		border-color: #f5222d;
	}

	.custom-size input,
	.template-name-input {
		width: 120px;
		padding: 6px 8px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		font-size: 14px;
		text-align: center;
	}

	.template-select {
		padding: 6px 8px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		font-size: 14px;
		background-color: #fff;
		cursor: pointer;
	}

	.custom-size span {
		font-size: 14px;
		color: #666;
	}

	/* 分页容器：固定高度，不参与滚动 */
	.hiprint-printPagination {
		background-color: #fafafa;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		padding: 8px 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		flex-wrap: wrap;
		font-size: 14px;
		flex-shrink: 0;
	}

	/* 画布容器：独立滚动，不会撑大父容器 */
	.designer-canvas {
		flex: 1;
		overflow: auto;
		/* 内容超出时滚动 */
		padding: 20px;
		background-color: #f0f2f5;
		min-height: 0;
		/* 重要：允许 flex 子项收缩 */
	}

	/* 右侧固定宽度，不压缩 */
	.designer-right {
		width: 300px;
		flex-shrink: 0;
		border-left: 1px solid #ddd;
		padding: 12px;
		background-color: #f8f9fa;
		overflow-y: auto;
	}

	.designer-right h3 {
		margin-top: 0;
		margin-bottom: 16px;
		font-size: 16px;
		text-align: center;
		color: #333;
	}
</style>